<template>
  <div class="container worry-about-risks">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="80" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip skip="almostdone">
    </back-and-skip>
    <div class="row pt-5 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/worry_about_risks.svg" alt="catch-covid">
      </div>
    </div>
    <div class="row row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('worryAboutRisk.title') }}
        </label>
      </div>
    </div>
    <yes-no
      @yes="yes"
      @no="no">
    </yes-no>
  </div>
</template>

<script>
import BackAndSkip from '../components/BackAndSkip.vue'
import YesNo from '../components/YesNoButtons.vue'

export default {
  components: {
    BackAndSkip,
    YesNo
  },
  methods: {
    yes () {
      const answer = {
        key: 'worry_about_risk_factor_after_vaccine',
        value: 'no'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'almostdone'
      })
    },
    no () {
      const answer = {
        key: 'worry_about_risk_factor_after_vaccine',
        value: 'no'
      }

      this.$store.commit('SET_DATA_SURVEY', answer)

      this.$router.push({
        name: 'almostdone'
      })
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'worryaboutrisks')
  }
}
</script>

<style>
.worry-about-risks .img-question {
  width: 100%;
  height: 27vh;
}

.worry-about-risks .title {
  font-weight: 700;
  font-size: 1.4rem;
}

.worry-about-risks .row-title {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

@media screen and (device-aspect-ratio: 40/71) {
  .worry-about-risks .img-question {
    height: 22vh;
  }

  .worry-about-risks .title {
    font-size: 1.1rem;
  }

  .worry-about-risks .row-title {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}
</style>
